import React, { useEffect, useMemo, useRef, useState } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import CloseIcon from "@mui/icons-material/Close";
import { Box, FormControlLabel, FormGroup, Grid, TextField, Typography, useMediaQuery } from "@mui/material";
import "../../../../Assets/Styles/Containers/_commentLibraryModal.scss";
import { toast } from "react-hot-toast";
import dayjs from "dayjs";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import parse from "html-react-parser";
import { useTheme } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import IconButton from "@mui/material/IconButton";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import LastPageIcon from "@mui/icons-material/LastPage";
import TableHead from "@mui/material/TableHead";
import TableSortLabel from "@mui/material/TableSortLabel";
import Checkbox from "@mui/material/Checkbox";
import { visuallyHidden } from "@mui/utils";
import Divider from "@mui/material/Divider";
import UnfoldMoreIcon from "@mui/icons-material/UnfoldMore";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import SearchIcon from "@mui/icons-material/Search";
import PublicIcon from "@mui/icons-material/Public";
import { useDispatch } from "react-redux";
import { addNewCommentNarrative, addSelectedCommentesFromCl, getCommentLibraryList, getCommentLibraryTagList, getCommentLibrarySummaryTagList, updateDropDownValues, updateInputValues, getDefectData, updateDefectData } from "../../../Helpers/ApiCall";
import { useSelector } from "react-redux";
import CircularProgress from "@mui/material/CircularProgress";
import { descendingComparator, filterSelectTag, preprocessHTMLContent, stableSort } from "./CommentLibraryHelper";
import axios from "axios";
import { aiUrl, origin } from "../../../Config/Api-constants";
import { Base64 } from "js-base64";
import CLAddCommentModal from "./CLAddCommentModal";
import { useLocation } from "react-router-dom";
import { clearDefaultCategories, getDefaultCategories, getInspectionDataWithOutLoader, setShowCommentLibraryModal } from "../../../Redux/Actions/CommonActions";
import CommentTags from "./CommentTags";
import { Tooltip } from "@mui/material";
import FilterTags from "./FilterTags";
import uuid from "react-uuid";
import CommentSettings from "./CommentSettings";
import { MaskSparkle, Sparkle } from "../../../../Assets/Svg/Svg";
import AIDefectFinder from "./AIDefectFinder";
<link href="https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;700&display=swap" rel="stylesheet"></link>

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div role="tabpanel" hidden={value !== index} id={`simple-tabpanel-${index}`} aria-labelledby={`simple-tab-${index}`} {...other}>
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

function TablePaginationActions(props) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton onClick={handleFirstPageButtonClick} disabled={page === 0} aria-label="first page">
        {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton onClick={handleBackButtonClick} disabled={page === 0} aria-label="previous page">
        {theme.direction === "rtl" ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
      </IconButton>
      <IconButton onClick={handleNextButtonClick} disabled={page >= Math.ceil(count / rowsPerPage) - 1} aria-label="next page">
        {theme.direction === "rtl" ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
      </IconButton>
      <IconButton onClick={handleLastPageButtonClick} disabled={page >= Math.ceil(count / rowsPerPage) - 1} aria-label="last page">
        {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>
  );
}

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  // rowsPerPage: PropTypes.number.isRequired,
};

function getComparator(order, orderBy) {
  return order === "desc" ? (a, b) => descendingComparator(a, b, orderBy) : (a, b) => -descendingComparator(a, b, orderBy);
}

const CommentLibraryModal = ({ lineData, templateId, lineUuid, categoryUuid, existingCommentUuids, categoryName, templateGuid, categoryId, categoryData }) => {
  const dispatch = useDispatch();
  const storeData = useSelector((state) => state.CommonReducer);
  const rowsPerPage = 10;
  const [value, setValue] = useState(0);
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("");
  const [selected, setSelected] = useState([]);
  const [page, setPage] = useState(0);
  const [expandedRows, setExpandedRows] = useState([]);
  const [commentListData, setCommentListData] = useState([]);
  const [initialTableData, setInitialTableData] = useState([]);
  const [commentTitle, setCommentTitle] = useState("");
  const [commentTag, setCommentTag] = useState([]);
  const [commentSummaryTag, setCommentSummaryTag] = useState([]);
  const [addToLibrary, setAddToLibrary] = useState(false);
  const [addToTemplate, setAddToTemplate] = useState(false);
  const [loading, setLoading] = useState(false);
  const [openData, setOpenData] = useState(false)
  const [images, setImages] = useState([]);
  const [medialLibery, setMedialLibery] = useState(true);
  const [defaultSelect, setDefaultSelect] = useState("")
  const [includeRecommendation, setIncludeRecommendation] = useState(false);
  const [selectedMediaFiles, setSelectedMediaFiles] = useState([])
  const [datas, setDatas] = useState({})
  const [dataLoading, setDataLoading] = useState({})
  const [additionalInfo, setAdditionalInfo] = useState('');
  const [selectedImages, setSelectedImages] = useState([]);
  const [commentChecked, setCommentChecked] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [selectedTone, setSelectedTone] = useState('professional');
  const [onDragtoggle, setOnDragToggle] = useState(false);
  const [tabValue, setTabValue] = useState('Short');
  const [commentText, setCommentText] = useState({ innerHTML: " ", dropdownList: [], selected_value: "" });
  const [commentSummary, setCommentSummary] = useState({ innerHTML: " ", dropdownList: [], selected_value: "" });
  const [selectedFilterTagID, setSelectedFilterTagID] = useState([]);
  const [searchData, setSearchData] = useState("");
  const [hasFetchedCompanySettings, setHasFetchedCompanySettings] = useState(false);
  const [reportWriterSettingsAccess, setReportWriterSettingsAccess] = useState(null);
  const [defectImages, setDefectImages] = useState([])
  const uploadIndexRef = useRef(0);
  const [checkbox, setCheckbox] = useState({
    individually: false,
    prompt: false
  })
  const [selectedContent, setSelectedContent] = useState(null)
  const [loader, setLoader] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  const [disable, setDisable] = useState(false);

  const location = useLocation();
  const categoryNameFromLocation = location?.state?.category_name;
  const showCommentLibraryModal = storeData?.showCommentLibraryModal;
  const inspectionData = storeData?.inspectionData?.data;
  const defectFinder = storeData?.defectData;

  useEffect(() => {
    if (value === 2 && sessionStorage.getItem("comKey") && sessionStorage.getItem("comKey")) {
      fetchDefectDetails()
    }
  }, [value]);

  const [searchInput, setSearchInput] = useState("");
  const debouncedSearch = useDebounce(searchInput, 500)

  function useDebounce(value, delay) {
    const [debouncedValue, setDebouncedValue] = useState(value);
    useEffect(() => {
      const handler = setTimeout(() => {
        setDebouncedValue(value);
      }, delay);
      return () => {
        clearTimeout(handler);
      };
    }, [value, delay]);
    return debouncedValue;
  }

  useEffect(() => {
    const accessFlag = storeData?.inspectionData?.data?.REPORT_WRITER_SETTINGS_ACCESS;
    if (accessFlag !== undefined) setReportWriterSettingsAccess(accessFlag);
    setHasFetchedCompanySettings(true);
  }, [showCommentLibraryModal, hasFetchedCompanySettings, storeData?.inspectionData?.data?.REPORT_WRITER_SETTINGS_ACCESS]);

  function EnhancedTableHead(props) {
    const { order, orderBy, onRequestSort } = props;
    const createSortHandler = (property) => (event) => {
      onRequestSort(event, property);
    };

    return (
      <TableHead>
        <TableRow>
          <TableCell padding="checkbox">
          </TableCell>
          {headCells.map((headCell) => (
            <TableCell key={headCell.id} align={headCell.id === "name" ? "center" : "left"} padding={headCell.disablePadding ? "none" : "normal"} sortDirection={orderBy === headCell.id ? order : false} className="cl-table-head">
              <TableSortLabel
                active={orderBy === headCell.id}
                direction={orderBy === headCell.id ? order : "asc"}
                onClick={createSortHandler(headCell.id)}
                IconComponent={() => (headCell.id !== "name" && headCell.id !== "global" ? <UnfoldMoreIcon className="cl-sort-icon" /> : "")}
              >
                {headCell.label}
                {orderBy === headCell.id ? (
                  <Box component="span" sx={visuallyHidden}>
                    {order === "desc" ? "sorted descending" : "sorted ascending"}
                  </Box>
                ) : null}
              </TableSortLabel>
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
    );
  }

  EnhancedTableHead.propTypes = {
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    order: PropTypes.oneOf(["asc", "desc"]).isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired,
  };

  const headCells = [
    {
      id: "name",
      numeric: false,
      disablePadding: true,
      label: <LastPageIcon className="cl-table-exp-icon" onClick={toggleAllRowsExpansion} />,
    },
    {
      id: "title",
      numeric: false,
      disablePadding: false,
      label: "Title",
    },
    {
      id: "comment",
      numeric: false,
      disablePadding: false,
      label: "Comment",
    },
    {
      id: "summary",
      numeric: false,
      disablePadding: false,
      label: "Summary",
    },
    {
      id: "rating",
      numeric: false,
      disablePadding: false,
      label: "Summary Section",
    },
    {
      id: "global",
      numeric: false,
      disablePadding: true,
      label: "",
    },
  ];

  useEffect(() => {
    if (showCommentLibraryModal) {
      setPage(0);
      getClListForSearch({
        page: 1,
        page_count: rowsPerPage,
        search: debouncedSearch.trim(),
        sort_field: orderBy,
        sort_direction: order,
        tags: selectedFilterTagID,
        category_uuid: categoryUuid,
        template_guid: templateGuid,
        category_id: categoryId,
      });
    }
  }, [debouncedSearch]);

  const toggleRowExpansion = (rowId) => {
    setExpandedRows((prevExpandedRows) => (prevExpandedRows.includes(rowId) ? prevExpandedRows.filter((id) => id !== rowId) : [...prevExpandedRows, rowId]));
  };

  const isRowExpanded = (rowId) => expandedRows.includes(rowId);

  function toggleAllRowsExpansion() {
    const allRowIds = commentListData?.map((row) => row.id);
    setExpandedRows((prevExpandedRows) => (prevExpandedRows.length === allRowIds.length ? [] : allRowIds));
  }

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  useEffect(() => {
    if (storeData?.showCommentLibraryModal) {
      setAddToTemplate(false);
    }
  }, [storeData?.showCommentLibraryModal])

  const handleSelectedTone = (val) => {
    setSelectedTone(val);
  }

  const handleClose = () => {
    dispatch(setShowCommentLibraryModal(false));
    setSelected([]);
    setCommentTitle("");
    setCommentText({ innerHTML: "", dropdownList: [], selected_value: "" });
    setCommentSummary({ innerHTML: "", dropdownList: [], selected_value: "" });
    setCommentTag([]);
    setCommentSummaryTag([]);
    setExpandedRows([]);
    setSearchInput("");
    // setSearch(false);
    setPage(0);
    setAddToLibrary(false);
    value !== 1 && setAddToTemplate(false);
    setSelectedFilterTagID([]);
    setSearchData("");
    setAdditionalInfo("")
    setImages([])
    setOpenData(false)
    setIncludeRecommendation(false);
    setSelectedMediaFiles([]);
    setSelectedImages([]);
    setMedialLibery(true);
    setCommentChecked(false);
    setSelectedContent(null)
    setDefaultSelect("")
    setLoading(false)
    setDatas({})
    setCheckbox({ individually: false, prompt: false })
    setTabValue("Short")
    setDisable(false)
    handleClearCategories();
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const selectedComment = commentListData?.map((n) => n.id);
      setSelected(selectedComment);
      return;
    }
    setSelected([]);
  };

  const handleClickChangeDropdown = (event, id, row, action) => {
    if (action !== "dropdown") {
      toggleRowExpansion(row.id);
    }
    const selectedIndex = selected.indexOf(row.uuid);
    if (action === "dropdown") {
      if (!isSelected(row.uuid)) {
        let newSelected = [];
        if (selectedIndex === -1) {
          newSelected = newSelected.concat(selected, row.uuid);
        } else if (selectedIndex === 0) {
          newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
          newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
          newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
        }
        setSelected(newSelected);
      }
    }
  };

  const getClListForSearch = async ({
    page = 1,
    page_count = 10,
    search = searchInput,
    sort_field = "",
    sort_direction = "asc",
    tags = [],
    category_uuid,
    template_guid,
    category_id,
  }) => {
    let baseUrl = await origin();
    let sessionAPIKey = sessionStorage.getItem("CK");
    let sessionSecretKey = sessionStorage.getItem("SK");
    try {
      const response = await axios.get(`${baseUrl}get-comment-library-list`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${Base64.decode(sessionSecretKey)}`,
          "api-key": `${Base64.decode(sessionAPIKey)}`,
          platform: "web",
          "api-platform": "WRW",
          user_id: sessionStorage.getItem("UID"),
          product: sessionStorage.getItem("asoCom"),
          mode: "online",
        },
        params: {
          page,
          page_count,
          search: search?.trim() || "",
          sort_field: sort_field || undefined,
          sort_direction,
          category_uuid,
          template_guid,
          category_id,
          ...(tags.length > 0 ? { tags } : {}),
        },
      });
      setInitialTableData(response?.data?.data?.data || []);
      setCommentListData(response?.data?.data?.data || []);
      setTotalCount(response?.data?.data?.total || 0);
      setLoader(false);
    } catch (error) {
      setLoader(false);
    }
  };
  const handleSelect = (name, id) => {
    const value = datas?.[name];
    setDefaultSelect(id)
    if (dataLoading[name] === true) return;
    setSelectedContent({ ...value, name: name });
  }
  const handleRetry = (val) => {
    handleNext(true, val)
  };

  const remainingImages = defectFinder?.defect_detector_counter - images.length;
  const MAX_FILE_SIZE = 20 * 1024 * 1024;
  const ALLOWED_TYPES = ["image/png", "image/jpeg", "image/jpg"];

  const handleImageUpload = (files) => {
    function formatBytes(bytes) {
      if (!bytes || bytes < 1024) return 0;
      const kb = bytes / 1024;
      if (kb < 1024) return `${Math.round(kb)} KB`;
      const mb = kb / 1024;
      return `${mb.toFixed(2)} MB`;
    }
    const remainingSlots = 10 - images.length;
    if (remainingSlots <= 0) {
      toast.error("Maximum of 10 images allowed");
      return;
    }

    const filesToProcess = files.slice(0, remainingSlots);

    const MAX_BYTES = 500 * 1024 * 1024; // 500 MB
    const filesWithinSize = filesToProcess.filter((f) => {
      const fileObj = f instanceof File ? f : (f?.file instanceof File ? f.file : null);
      return !fileObj || (typeof fileObj.size === "number" && fileObj.size <= MAX_BYTES);
    });

    const now = dayjs().format("YYYY-MM-DD HH:mm:ss");

    const newImages = filesWithinSize.map((f, index) => {
      const isFileObject = typeof f !== "string" && (f instanceof File || f?.file instanceof File);
      const urlString = typeof f === "string" ? f : (typeof f?.file === "string" ? f.file : null);

      const fileObj = isFileObject ? (f instanceof File ? f : f.file) : null;

      const displayName =
        fileObj?.name ||
        f?.name ||
        (urlString ? urlString.split("/").pop() : "image");

      const byteSize = fileObj?.size || f?.size || 0;

      return {
        // Media dragged from the RML quick access bar keeps its library uuid, with id
        // matching it, so the add-comment payload links the existing RML row.
        id: f?.uuid || uuid(),
        ...(f?.uuid ? { uuid: f.uuid } : {}),
        url: null,
        name: displayName,
        size: byteSize,
        type: fileObj?.type || f?.type || "image/jpeg",
        edited: false,
        newUrl: null,
        online: "online",
        filetype: "image",
        localUrl: null,
        OriginUrl: null,
        created_at: now,
        editCount: 0,
        onlineUrl: null,
        orginName: null,
        thumbnail: null,
        is_deleted: 0,
        order: images.length + index + 1,
        uploaded_by: parseInt(sessionStorage.getItem("UID")) || null,
        updated_at: now,
        description: null,
        OriginlocalUrl: null,
        isOriginUploaded: true,
        file: fileObj || (urlString ? { file: urlString } : f),
        preview: urlString || fileObj || f,
      };
    });

    if (newImages.length) {
      setImages((prev) => [...prev, ...newImages]);
    }

    if (files.length > remainingSlots) {
      toast.error(`Only ${remainingSlots} images added. Maximum of 10 images allowed.`);
    }
    // if (files.length > remainingImages) {
    //   toast.error(`You’ve reached today’s limit of 100 images. New slots will be available tomorrow.`);
    // }
  };

  const handleRemoveImage = (id) => {

    setImages(prev => {
      const imageToRemove = prev.find(img => img.id === id);
      if (imageToRemove) {
        URL.revokeObjectURL(imageToRemove.preview);
      }
      return prev.filter(img => img.id !== id);
    });
  };

  const handleCheckbox = (fileName, isChecked) => {
    setDatas((prev) => {
      const updatedData = { ...prev };
      if (updatedData[fileName]) {
        updatedData[fileName] = {
          ...updatedData[fileName],
          checked: isChecked
        };
      }
      return updatedData;
    });
  };

  const getPromptTemplate = (tabValue, includeRecommendation) => {
    if (defectFinder?.defect_detector_prompts?.prompt) {
      if (tabValue === 'Short' && !includeRecommendation) {
        return defectFinder?.defect_detector_prompts?.prompt?.short;
      } else if (tabValue === 'Long' && !includeRecommendation) {
        return defectFinder?.defect_detector_prompts?.prompt?.long;
      } else if (tabValue === 'Short' && includeRecommendation) {
        return defectFinder?.defect_detector_prompts?.prompt?.short_with_recommendation;
      } else if (tabValue === 'Long' && includeRecommendation) {
        return defectFinder?.defect_detector_prompts?.prompt?.long_with_recommendation;
      } else {
        return '';
      }
    } else {
      return '';
    }
  }

  function formatAIResponseToHTMLTitle(text) {
    if (!text) return { html: "", title: "" };
    let title = "";
    const titleMatch = text.match(/Title:\s*(.*)/i);
    if (titleMatch) {
      title = titleMatch[1].trim();
      text = text.replace(titleMatch[0], "");
    }
    return title

  }

  function formatAIResponseToHTML(text) {
    if (!text) return "";

    // make sure it's always a string
    text = String(text);

    text = text.replace(/#+|[*]{2}/g, "").trim();

    let bulletCount = 1;
    const processed = text.split("\n").map((line) => {
      line = line.trim();
      if (!line || /^Title\s*:/i.test(line)) return "";

      if (/Summary\s*-/.test(line)) {
        return `Summary - ${line.replace(/Summary\s*-\s*/, "")}`;
      }
      if (/^[-•–]\s+/.test(line)) {
        return `${bulletCount++}. ${line.replace(/^[-•–]\s+/, "")}`;
      }
      if (/^\s+[-•–]\s+/.test(line)) {
        return `&nbsp;&nbsp;&nbsp;&nbsp;• ${line.replace(/^\s*[-•–]\s+/, "")}`;
      }
      return line;
    });

    return processed.filter(Boolean).join("<br/>");
  }

  const getCharacterLimit = (tabValue) => {
    if (defectFinder?.defect_detector_prompts?.char_limits) {
      if (tabValue === 'Short') {
        return defectFinder?.defect_detector_prompts?.char_limits?.char_limit_default;
      } else if (tabValue === 'Long') {
        return defectFinder?.defect_detector_prompts?.char_limits?.char_limit_longer;
      } else {
        return '';
      }
    } else {
      return '';
    }
  }
  function generateComment(template = '', category = '', line = '', issue = '', charLimit = '') {
    return template
      .replace("'{{category}}'", category || '')
      .replace("'{{line_item}}'", line || '')
      .replace("'{{user_prompt}}'", issue || '')
      .replace("'{char_limit_default}'", charLimit)
      .replace("'{char_limit_longer}'", charLimit)
      .replace("'{char_limit}'", charLimit);
  }

  function aiEnvUrl() {
    if (window.location.hostname === "portal.palmtech.com") {
      return "https://prod-genie-ai.inspectionsupport.com/api/gpt/upload-and-analyse/"
    } else {
      return "https://staging-genie-ai.inspectionsupport.com/api/gpt/upload-and-analyse/"
    }
  }

  function aiEnvToken() {
    if (window.location.hostname === "portal.palmtech.com") {
      return "token 1854f0ae670ad92120482d3f233da72cfab4c41c"
    } else {
      return defectFinder?.ai_token
    }
  }

  const handleNext = async (status, value) => {
    const currentPromptTemplate = getPromptTemplate(tabValue, includeRecommendation);
    const currentPromptLimit = getCharacterLimit(tabValue);

    const result = generateComment(currentPromptTemplate, categoryName, lineData?.prompt, additionalInfo, currentPromptLimit);
    try {
      setLoading(true);
      const firstImageFileName = images[0].id;
      if (!status) {
        const updateLoading = Object.fromEntries(images.map(img => [img.file.name || img.name, true]));
        const updateData = Object.fromEntries(images.map(img => [img.file.name || img.name, , null]));
        setDatas(updateData);
        setDefaultSelect(firstImageFileName);
        setDataLoading(updateLoading);
        let successCount = 0;

        // Handle multiple uploads in parallel
        await Promise.all(
          images.map(async (img) => {
            const formData = new FormData();
            const isDrag = typeof img.file?.file === "string";
            // Attach either binary file or S3 URL
            if (img.file instanceof File || img.file instanceof Blob) {
              formData.append("file", img.file);
            } else if (typeof img.file?.file === "string") {
              formData.append("s3_image_urls", img.file.file);
            }
            formData.append("prompt", result)
            // formData.append("process_image_individually", commentChecked)
            try {
              const res = await axios.post(
                aiUrl(),
                formData,
                {
                  headers: {
                    Authorization: defectFinder?.ai_token || '',
                    "Content-Type": "multipart/form-data",
                  },
                }
              );

              if (res.status === 200) {
                successCount++;
                if (isDrag) {
                  setDatas((prev) => ({ ...prev, [img.name]: { ...res.data, checked: false, file: img } }));
                  setDataLoading((prev) => ({ ...prev, [img.name]: false }));
                }
                setDatas((prev) => ({ ...prev, [img.file.name]: { ...res.data, checked: false, file: img } }));
                setDataLoading((prev) => ({ ...prev, [img.file.name]: false }));
                if (img.id === firstImageFileName && isDrag) {
                  const update = { ...res.data, [img.name]: false, name: img.name, file: img };
                  setSelectedContent((prev) => (prev === null ? update : prev));
                }
                else if (img.id === firstImageFileName) {
                  const update = { ...res.data, [img.file.name]: false, name: img.file.name, file: img };
                  setSelectedContent((prev) => (prev === null ? update : prev));
                }
              }
            } catch (err) {
              console.error("Upload error:", err);
              setDataLoading((prev) => ({ ...prev, [img.file.name]: "error" }));
            }
          })
        );
        handleupdateDefectQuotacount(successCount);
        setAdditionalInfo("");
      } else {
        setDataLoading((prev) => ({ ...prev, [value?.name]: true }));

        const retryForm = new FormData();
        if (value.file instanceof File || value.file instanceof Blob) {
          retryForm.append("file", value.file);
        } else if (typeof value.file?.file === "string") {
          retryForm.append("s3_image_urls", value.file.file);
        } retryForm.append("prompt", result);

        try {
          const res = await axios.post(
            aiUrl(),
            retryForm,
            {
              headers: {
                Authorization: defectFinder?.ai_token || '',
                "Content-Type": "multipart/form-data",
              },
            }
          );

          if (res.status === 200) {
            setDataLoading((prev) => ({ ...prev, [value.name]: false }));
            setDatas((prev) => ({ ...prev, [value.name]: res.data }));
            setSelectedContent(res.data);
            handleupdateDefectQuotacount(1);
          }
        } catch (err) {
          setDataLoading((prev) => ({ ...prev, [value.name]: "error" }));
          console.error("Retry upload error:", err);
        } finally {
          setAdditionalInfo("");
        }
      }
    } catch (error) {
      console.error("Error during handleNext:", error);
    }
  };

  const handleupdateDefectQuotacount = (successCount) => {
    updateDefectData(dispatch, {
      company_key: sessionStorage.getItem("comKey") || "",
      associate_company: sessionStorage.getItem("asoCom") || "",
      counter: defectFinder?.defect_detector_counter - successCount,
    }
    )
  };

  const fetchDefectDetails = () => {
    getDefectData(dispatch, {
      company_key: sessionStorage.getItem("comKey") || "",
      associate_company: sessionStorage.getItem("asoCom") || ""
    })
  }

  const RenderContent = () => {
    return (

      <div>
        <div className="fill_content">
          <span style={{ fontSize: isMobile ? "10px" : "11px", color: "#979797", fontFamily: "Open Sans" }}>
            JPG, JPEG, PNG | Max size: 20 MB | Max 10 images
          </span>
          <span style={{ fontSize: isMobile ? "10px" : "11px", color: "#979797", fontFamily: "Open Sans" }}>
            {images.length}/10 images selected | {defectFinder?.defect_detector_counter && defectFinder.defect_detector_counter} credits remaining today
          </span>
        </div>
        {/* {images.length > 1 &&
          <div style={{ display: "flex", alignItems: "center", marginTop: "15px", paddingRight: "20px", flexDirection: "reverse" }}>

            <Checkbox onChange={(e) => setCommentChecked(e.target.checked)} sx={{ marginLeft: "-10px" }} />
            <span style={{ color: "#757575", fontWeight: 400 }}>Process Image Individually</span>
          </div>
        } */}

        <Box>
          <Typography fontWeight={500} color={"#333333"} sx={{ fontSize: "16px !important", fontFamily: "Open Sans" }}>Comment Generation Options</Typography>          <CommentSettings
            selectedTone={selectedTone}
            onToneChange={handleSelectedTone}
            includeRecommendation={includeRecommendation}
            onRecommendationChange={setIncludeRecommendation}
            tabValue={tabValue}
            setTabValue={setTabValue}
            lastBtn={false}
          />
          <Typography variant="body2" sx={{ mb: 1, color: "#757575", fontWeight: 400, mt: 1 }}>
            Add context (optional)
            {/* <InfoAddContext/> */}
          </Typography>
          <TextField
            fullWidth
            value={additionalInfo}
            onChange={(e) => setAdditionalInfo(e.target.value)}
            placeholder="Rusted material, broken pieces, etc."
            sx={{
              fontSize: "14px !important",
              '& .MuiOutlinedInput-root': {
                height: '40px',
                fontSize: "14px !important",
                fontWeight: 400,

                backgroundColor: "#FFFFFF",
                color: '#454545',
                '& fieldset': {
                  fontSize: "14px !important",
                  borderColor: '#D5D5D5',
                  borderWidth: '1px',
                },
                '&:hover fieldset': {
                  fontSize: "14px !important",
                  borderColor: '#D5D5D5',
                },
                '&.Mui-focused fieldset': {
                  fontSize: "14px !important",
                  borderColor: '#D5D5D5',
                  borderWidth: '1px',
                },
              },
            }}
          />
          {/* <div style={{ display: "flex", alignItems: "center" }}>
            <Checkbox onChange={(e) => setCheckbox((prev) => ({ ...prev, prompt: e.target.checked }))} sx={{ marginLeft: "-10px" }} />
            <span style={{ color: "#757575", fontWeight: 400 }}> Use custom prompt</span>
          </div> */}
        </Box>
      </div>
    )
  }
  const checkedCount = Object.values(datas).filter(item => item?.checked).length;

  const getButtonLabel = () => {
    if (value === 1) return "Add new comment";
    if (value === 0) return `Add ${selected?.length} comments`;
    if (loading || selectedContent) {
      return `Add ${checkedCount} comments`;
    }
    return "Analyze images";
  };

  const handleClick = (event, id, row) => {
    event.stopPropagation();
    toggleRowExpansion(id);
    const selectedIndex = selected.indexOf(row.uuid);
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, row.uuid);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
    }
    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    getClListForSearch({
      page: newPage + 1,
      page_count: rowsPerPage,
      search: debouncedSearch.trim(),
      sort_field: orderBy,
      sort_direction: order,
      tags: selectedFilterTagID,
      category_uuid: categoryUuid,
      template_guid: templateGuid,
      category_id: categoryId,
    });
  };

  const isSelected = (id) => selected.indexOf(id) !== -1;

  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - commentListData?.length) : 0;

  const visibleRows = useMemo(() => stableSort(commentListData, getComparator(order, orderBy)), [order, orderBy, page, rowsPerPage, commentListData]);

  const handleAddSelectedComment = () => {
    let payload = {
      comment_uuid: selected,
      inspection_id: storeData?.inspectionData?.data?.inspection_id,
      template_id: templateId,
      category_uuid: categoryUuid,
      line_uuid: lineUuid,
      inspection_guid: storeData.inspectionData?.data?.guid,
    };
    addSelectedCommentesFromCl(dispatch, payload);
    handleClose();
  };

  const replacePlaceholdersWithDropdowns = (htmlString, dropdowns, type, commentId, commentUUId, rowDisabled, isTruncate, maxLength) => {
    let newHtmlString = htmlString;
    if (isTruncate) {
      const textboxRegex = /\[textbox[^\]]*\]/g;
      const dropdownRegex = /\[dropdown [a-f0-9\-]+\]/g;
      const textboxMatches = htmlString?.match(textboxRegex) || [];
      const dropdownMatches = htmlString?.match(dropdownRegex) || [];
      if (textboxMatches.length > 0 || dropdownMatches.length > 0) {
        let result = "";
        let currentLength = 0;
        let remainingString = htmlString;
        while (remainingString.length > 0 && currentLength < maxLength) {
          const nextTextboxIndex = remainingString.indexOf('[textbox');
          const nextDropdownIndex = remainingString.indexOf('[dropdown');
          let nextElementIndex = -1;
          let elementType = '';
          if (nextTextboxIndex !== -1 && nextDropdownIndex !== -1) {
            if (nextTextboxIndex < nextDropdownIndex) {
              nextElementIndex = nextTextboxIndex;
              elementType = 'textbox';
            } else {
              nextElementIndex = nextDropdownIndex;
              elementType = 'dropdown';
            }
          } else if (nextTextboxIndex !== -1) {
            nextElementIndex = nextTextboxIndex;
            elementType = 'textbox';
          } else if (nextDropdownIndex !== -1) {
            nextElementIndex = nextDropdownIndex;
            elementType = 'dropdown';
          }
          if (nextElementIndex === -1) {
            const remainingChars = maxLength - currentLength;
            result += remainingString.substring(0, remainingChars);
            break;
          }
          if (nextElementIndex > 0) {
            const textBefore = remainingString.substring(0, nextElementIndex);
            const textBeforeLength = textBefore.length;
            if (currentLength + textBeforeLength <= maxLength) {
              result += textBefore;
              currentLength += textBeforeLength;
            } else {
              const remainingChars = maxLength - currentLength;
              result += textBefore.substring(0, remainingChars);
              break;
            }
          }
          const elementEndIndex = remainingString.indexOf(']', nextElementIndex);
          if (elementEndIndex !== -1) {
            const fullElement = remainingString.substring(nextElementIndex, elementEndIndex + 1);
            result += fullElement;
            remainingString = remainingString.substring(elementEndIndex + 1);
          } else break;
        }
        if (result.length < htmlString.length && !result.endsWith('...')) result += '...';
        newHtmlString = result;
      } else {
        newHtmlString = htmlString?.slice(0, maxLength);
        if (newHtmlString.length < htmlString.length) newHtmlString += '...';
      }
    }
    const regexSpecialSymbol = /Ã|Â|ÃÂ/g;
    if (Array?.isArray(dropdowns) && dropdowns?.length > 0) {
      dropdowns?.forEach((dropdown) => {
        const placeholder = `\\[dropdown ${dropdown.dropdown_uuid}\\]`;
        const regex = new RegExp(placeholder, "g");
        const selectElement = document.createElement("select");
        if (Array?.isArray(dropdown?.dropdowns_values?.values)) {
          let newDropdownValues = dropdown?.dropdowns_values?.values;
          newDropdownValues = newDropdownValues?.filter((obj) => !obj?.toUpperCase()?.includes("XXX"));
          if (!newDropdownValues?.find((value) => value?.includes("-----"))) {
            newDropdownValues?.unshift("-------------");
          }
          newDropdownValues?.forEach((value) => {
            const option = document.createElement("option");
            if (value?.length > 40) option.text = `${value.substring(0, 40)}...`;
            else option.text = value;
            option.value = value;
            option.title = value;
            selectElement.appendChild(option);
            if (dropdown.selected_value === value) {
              option.setAttribute("selected", "selected");
            }
            selectElement.classList.add(`${type}-cl-dropdown`);
            selectElement.setAttribute("id", `${dropdown.dropdown_uuid}`);
            selectElement.setAttribute("comment_id", commentId);
            selectElement.setAttribute("comment_uuid", commentUUId);
            selectElement.setAttribute("dropType", type);
            if (rowDisabled) {
              selectElement.setAttribute("disabled", "true");
            } else {
              selectElement.removeAttribute("disabled");
            }
          });
        } else if (Array?.isArray(dropdown?.dropdowns_values)) {
          let newDropdownValues = dropdown?.dropdowns_values;
          newDropdownValues = newDropdownValues?.filter((obj) => !obj?.toUpperCase()?.includes("XXX"));
          if (!newDropdownValues?.find((value) => value?.includes("-----"))) {
            newDropdownValues?.unshift("-------------");
          }
          newDropdownValues?.forEach((value) => {
            const option = document.createElement("option");
            if (value?.length > 40) option.text = `${value.substring(0, 40)}...`;
            else option.text = value;
            option.value = value;
            option.title = value;
            selectElement.appendChild(option);
            if (dropdown.selected_value === value) {
              option.setAttribute("selected", "selected");
            }
            selectElement.classList.add(`${type}-cl-dropdown`);
            selectElement.setAttribute("id", `${dropdown.dropdown_uuid}`);
            selectElement.setAttribute("comment_id", commentId);
            selectElement.setAttribute("comment_uuid", commentUUId);
            selectElement.setAttribute("dropType", type);
            if (rowDisabled) {
              selectElement.setAttribute("disabled", "true");
            } else {
              selectElement.removeAttribute("disabled");
            }
          });
        }
        newHtmlString = newHtmlString?.replace(regex, selectElement?.outerHTML);
      });
    } else {
      const regexPlainDropdown = /\[dropdown [a-f0-9\-]+\]/g;
      newHtmlString = newHtmlString?.replace(regexPlainDropdown, (match) => {
        const selectId = match.match(/[a-f0-9\-]+/)?.[0] || '';
        return `<select id="${selectId}" class="${type}-cl-dropdown"><option>--------------</option></select>`;
      });
    }
    const replaceInputs = (input_text) => {
      let container = document.createElement("div");
      container.innerHTML = input_text;
      container.innerHTML = container.innerHTML.replace(/\[textbox(.*?)\]/g, (match, attributes) => {
        let idMatch = attributes.match(/id:([^;]+);?/);
        let valueMatch = attributes.match(/value:([^;]+);?/);
        let id = idMatch && idMatch[1].length > 30 ? idMatch[1].trim() : uuid();
        let value = valueMatch ? valueMatch[1].trim() : "";
        const safeValue = value.replace(/\\/g, "\\\\").replace(/"/g, '&quot;');
        return `<input id="${id}" value="${safeValue}" title="${safeValue}" readOnly class="${type}-cl-input" comment_uuid=${commentUUId} style="width: 104px;
                background-color: #f1f9fe;
                height: 24px;
                overflow-wrap: break-word;
                padding: 1px 17px 3px 6px;
                border-radius: 4px;
                border: 1px solid #0F75BC;
                appearance: none;
                -webkit-appearance: none;
                -moz-appearance: none;
                font-size: 14px;
                color: #3B3B3B;
                font-style: normal;
                font-weight: 600;
                max-width: 200px;
                min-width: 104px;
                text-overflow: ellipsis;
                white-space: nowrap;"
                onblur="handleChangeInput(id, value)"
                />`;
      });
      return container.innerHTML;
    }
    newHtmlString = replaceInputs(newHtmlString);
    if (isTruncate) {
      const parser = new DOMParser();
      const parsedDocument = parser.parseFromString(newHtmlString, "text/html");
      const correctedHtml = parsedDocument.body.innerHTML;
      return parse(correctedHtml?.replace(regexSpecialSymbol, ""));
    }
    return parse(newHtmlString?.replace(regexSpecialSymbol, "")) || "";
  };

  const handleChangeDropdown = (event, dropdownUuid, commentId, type, commentUUId, commentDisabled) => {
    if (event && typeof event.stopPropagation === "function") {
      event.stopPropagation();
    }
    commentDisabled === "false" && handleClickChangeDropdown(event, commentId, { id: commentId, uuid: commentUUId }, "dropdown");
    const selectedValue = event.target.value;
    const dropdownValuesArrays = commentListData.map((item) => {
      const commentDropdowns = item.comment_dropdowns || [];
      const summaryDropdowns = item.summary_comment_dropdowns || [];
      const allDropdowns = [...commentDropdowns, ...summaryDropdowns];
      return allDropdowns?.filter((dropdown) => dropdown?.dropdown_uuid === dropdownUuid)?.map((dropdown) => dropdown?.dropdowns_values?.values);
    });
    const dropdownValues = dropdownValuesArrays.flat().find((values) => values.length > 0);
    let payload = {
      comment_id: commentId,
      dropdown_uuid: dropdownUuid,
      dropdown_type: type === "comment" ? "1" : "2",
      selected_value: selectedValue,
      dropdowns_values: dropdownValues,
    };
    updateDropDownValues(dispatch, payload);
    let commentIndex = commentListData?.findIndex((item) => item.uuid === commentUUId);
    if (commentIndex !== -1) {
      if (type === "comment") {
        commentListData[commentIndex].comment_dropdowns?.forEach((dropdown) => {
          if (dropdown?.dropdown_uuid === dropdownUuid) {
            dropdown.selected_value = selectedValue;
          }
        });
      } else {
        commentListData[commentIndex].summary_comment_dropdowns?.forEach((dropdown) => {
          if (dropdown?.dropdown_uuid === dropdownUuid) {
            dropdown.selected_value = selectedValue;
          }
        });
      }
      setCommentListData([...commentListData]);
    }
  };

  setTimeout(() => {
    let commentDropElements = document.querySelectorAll(".comment-cl-dropdown");
    commentDropElements?.forEach((element) => {
      const commentId = element.getAttribute("comment_id");
      const dropType = element.getAttribute("dropType");
      const commentUUId = element.getAttribute("comment_uuid");
      const commentDisabled = element.hasAttribute("disabled");
      if (element && !commentDisabled) {
        const stopPropagation = (event) => {
          if (event && typeof event.stopPropagation === "function") {
            event.stopPropagation();
          }
        };
        element.onclick = stopPropagation;
        element.onmousedown = stopPropagation;
        element.onfocus = stopPropagation;
        element.onchange = (event) => {
          handleChangeDropdown(event, element.id, commentId, dropType, commentUUId, commentDisabled);
        };
      }
    });
  }, 100);

  setTimeout(() => {
    let summaryDropElements = document.querySelectorAll(".summary-cl-dropdown");
    summaryDropElements?.forEach((element) => {
      const commentId = element.getAttribute("comment_id");
      const dropType = element.getAttribute("dropType");
      const commentUUId = element.getAttribute("comment_uuid");
      const commentDisabled = element.hasAttribute("disabled");
      if (element && !commentDisabled) {
        const stopPropagation = (event) => {
          if (event && typeof event.stopPropagation === "function") {
            event.stopPropagation();
          }
        };
        element.onclick = stopPropagation;
        element.onmousedown = stopPropagation;
        element.onfocus = stopPropagation;
        element.onchange = (event) => handleChangeDropdown(event, element.id, commentId, dropType, commentUUId, commentDisabled);
      }
    });
  }, 100);

  const handleClearCategories = () => {
    dispatch(clearDefaultCategories())
  }
  const handleUpload = async (defectImages, data) => {
    try {
      let baseUrl = await origin();
      let sessionAPIKey = sessionStorage.getItem("CK");
      let sessionSecretKey = sessionStorage.getItem("SK");
      let formData = new FormData();
      // detect drag-and-drop vs system upload
      const isDrag = typeof defectImages.file?.file.file === "string";
      const fileOrUrl = isDrag ? defectImages.file?.file?.file : defectImages.file?.file;


      formData.append("image", fileOrUrl);
      formData.append("video_thumbnail", fileOrUrl);

      // Attach metadata
      formData.append("img_object", JSON.stringify({
        "id": defectImages.file.id,
        "url": null,
        "name": defectImages.file.name,
        "size": defectImages.file.size,
        "type": defectImages.file.type,
        "edited": false,
        "newUrl": null,
        "online": "online",
        "filetype": defectImages.file.filetype,
        "localUrl": null,
        "OriginUrl": null,
        "created_at": new Date().toISOString().replace('T', ' ').substring(0, 19),
        "editCount": 0,
        "onlineUrl": null,
        "orginName": null,
        "thumbnail": null,
        "is_deleted": 0,
        "order": 1,
        "uploaded_by": parseInt(sessionStorage.getItem("UID")),
        "updated_at": new Date().toISOString().replace('T', ' ').substring(0, 19),
        "description": null,
        "OriginlocalUrl": null,
        "isOriginUploaded": true
      }));
      formData.append("inspection_guid", sessionStorage.getItem('guid') || "")
      formData.append("template_id", templateId);
      formData.append("category_id", categoryUuid);
      formData.append("line_id", lineUuid);
      formData.append("uploaded_by", parseInt(sessionStorage.getItem("UID")));
      formData.append("img_type", "comment");
      formData.append("comment_id", data?.comment?.uuid);

      // Upload
      const response = await axios.post(
        `${baseUrl}upload_media_for_inspection_template`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${Base64.decode(sessionSecretKey)}`,
            "api-key": Base64.decode(sessionAPIKey),
            platform: "web",
            "api-platform": "WRW",
            user_id: sessionStorage.getItem("UID"),
            product: sessionStorage.getItem("asoCom"),
            mode: "online",
          },
        }
      );

      let sessionAssociateCompanyKey = Base64.decode(sessionStorage.getItem('AC'));
      let guid = sessionStorage.getItem('guid')
      let sessionUserId = Base64.decode(sessionStorage.getItem('UI'));
      dispatch(getInspectionDataWithOutLoader({ guid: guid, associate_company: sessionAssociateCompanyKey, user_id: sessionUserId }))

    } catch (error) {
      console.error("Upload error:", error.response?.data || error.message);
    }
  };

  const handleAnalyseDefect = async () => {

    setDisable(true)
    // Get all checked items
    const checkedItems = Object.keys(datas).filter(
      (key) => datas[key]?.checked
    );

    // Process items sequentially
    for (const key of checkedItems) {
      const aiResponse = datas[key]?.ai_response;
      const defectImages = datas[key];
      const title = formatAIResponseToHTMLTitle(aiResponse);
      const isDrag = typeof defectImages?.file?.file?.file === "string";

      const inputControls = isDrag ? [
        {
          type: "Media",
          data: [{
            ...defectImages.file,
            name: getFileNameFromUrl(defectImages.file?.file?.file || ''),
            OriginUrl: getPathFromUrl(defectImages.file?.file?.file || ''),
            onlineUrl: getPathFromUrl(defectImages.file?.file?.file || ''),
            thumbnail: getPathFromUrl(defectImages.file?.file?.file || ''),
            thumbnail_url: getPathFromUrl(defectImages.file?.file?.file || ''),
            OriginThumbnail: getPathFromUrl(defectImages.file?.file?.file || '')
          }],
          prompt: "Media",
          updated_at: new Date().toISOString().replace("T", " ").substring(0, 19),
          uuid: uuid()
        }
      ] : [];

      let payload = {
        template_id: templateId,
        category_uuid: categoryUuid,
        line_uuid: lineUuid,
        title: title || "",
        tag_ids: commentTag
          ?.filter((item) => item !== "")
          ?.map((tag) => parseInt(tag.id)),
        summary_ids: commentSummaryTag
          ?.filter((item) => item !== "")
          ?.map((summaryTag) => parseInt(summaryTag.id)),
        comment: formatAIResponseToHTML(aiResponse),
        summary: `${filterSelectTag(commentSummary?.innerHTML)}`,
        comment_dropdowns: commentText?.dropdownList,
        summary_comment_dropdowns: commentSummary?.dropdownList,
        add_to_library: addToLibrary,
        add_to_template: addToTemplate,
        category_parent_uuid: categoryData?.parent_uuid,
        inspection_guid: storeData.inspectionData?.data?.guid,
        ...(isDrag ? { comment_input_controls: inputControls } : {}),
      };

      try {
        // 1. Wait for comment creation to complete
        const response = await addNewCommentNarrative(dispatch, payload);

        // 2. If NOT drag (regular file upload), immediately upload the file
        if (!isDrag && defectImages?.file) {
          await handleUpload(defectImages, response);
        }

        console.log(`Successfully processed item: ${key}`);

      } catch (error) {
        console.error(`Error processing item ${key}:`, error);
        // Continue with next item or break based on your requirements
      }
    }

    handleClose();
  };

  const handleAddNewComment = () => {
    console.log("commentText", commentText)
    let payload = {
      template_id: templateId,
      category_uuid: categoryUuid,
      line_uuid: lineUuid,
      title: commentTitle,
      tag_ids: commentTag?.filter((item) => item !== "")?.map((tag) => parseInt(tag.id)),
      summary_ids: commentSummaryTag?.filter((item) => item !== "")?.map((summaryTag) => parseInt(summaryTag.id)),
      comment: `${filterSelectTag(commentText?.innerHTML)}`,
      summary: `${filterSelectTag(commentSummary?.innerHTML)}`,
      comment_dropdowns: commentText?.dropdownList,
      summary_comment_dropdowns: commentSummary?.dropdownList,
      add_to_library: addToLibrary,
      add_to_template: addToTemplate,
      category_parent_uuid: categoryData?.parent_uuid,
      inspection_guid: storeData.inspectionData?.data?.guid,
    };
    addNewCommentNarrative(dispatch, payload);
    handleClose();
  };
  function getPathFromUrl(url) {
    const urlObj = new URL(url);
    return urlObj.pathname.slice(1);
  }

  function getFileNameFromUrl(url) {
    const parts = url.split('/');
    return parts[parts.length - 1];
  }

  const addCommentResponse = storeData?.addCommentResponse;
  useEffect(() => {
    if (addCommentResponse?.comment && addToTemplate) {
      let templateIndex = inspectionData?.inspectiontemplates?.findIndex((itm) => itm.template_id === templateId);
      let categoryIndex = inspectionData?.inspectiontemplates[templateIndex]?.categories?.findIndex((itm) => itm.id === categoryId);
      let lineIndex = inspectionData?.inspectiontemplates[templateIndex]?.categories[categoryIndex]?.lines?.findIndex((line) => line.uuid === lineUuid);
      let prevData = JSON.parse(JSON.stringify(inspectionData));
      delete prevData?.report_media_library_files;
      prevData.inspectiontemplates[templateIndex].categories[categoryIndex].lines[lineIndex].comments.push(addCommentResponse?.comment);
      let addToTemplateApiPayload = {
        template_guid: prevData.inspectiontemplates[templateIndex]?.master_template_guid,
        categoryUuid: prevData.inspectiontemplates[templateIndex].categories[categoryIndex]?.uuid,
        lineUuid: lineUuid,
        comment: addCommentResponse?.comment,
        categoryParentUuid: prevData.inspectiontemplates[templateIndex].categories[categoryIndex]?.parent_uuid,
        lineParentUuid: prevData.inspectiontemplates[templateIndex].categories[categoryIndex].lines[lineIndex]?.parent_uuid
      }
      let baseUrl = origin();
      let sessionAPIKey = sessionStorage.getItem("CK");
      let sessionSecretKey = sessionStorage.getItem("SK");
      axios.post(`${baseUrl}master-template/add-comment`, addToTemplateApiPayload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${Base64.decode(sessionSecretKey)}`,
          "api-key": `${Base64.decode(sessionAPIKey)}`,
          platform: "web",
          "api-platform": "WRW",
        },
      });
      setAddToTemplate(false);
    }
  }, [addCommentResponse, addToTemplate])

  useEffect(() => {
    if (!storeData?.getClListStatus) {
      toast.error(storeData?.commentLibraryListData?.data?.message);
    }
  }, [storeData?.commentLibraryListData, storeData?.getClListStatus]);

  useEffect(() => {
    if (showCommentLibraryModal) {
      setLoader(true);
      getClListForSearch({
        page: 1,
        page_count: rowsPerPage,
        category_uuid: categoryUuid,
        template_guid: templateGuid,
        category_id: categoryId,
      });
      dispatch(getDefaultCategories(`?category_uuid=${categoryUuid}&template_guid=${templateGuid}&is_narrative_template=1`));
      getCommentLibraryTagList(dispatch);
      getCommentLibrarySummaryTagList(dispatch);
      setValue(0);
    }
  }, [showCommentLibraryModal]);

  useEffect(() => {
    if (storeData?.getClListStatus && storeData.commentLibraryListData) {
      setInitialTableData(storeData.commentLibraryListData.data);
      setCommentListData(storeData.commentLibraryListData.data);
    }
  }, [storeData.commentLibraryListData]);

  useEffect(() => {
    if (storeData.commentLibraryListData) getClListForSearch(storeData?.commentLibraryListData?.total);
  }, [storeData.commentLibraryListData]);

  const TruncatedText = (props) => {
    const { text, expanded, fieldType, commentDropdowns, textType, rowId, rowUuid, rowDisabled } = props;
    const calculationLimit = fieldType === "title" ? 20 : fieldType === "comment_text" ? 120 : 20;
    const truncationLimit = calculationLimit * 1.1;
    const getTotalCharacterCountFromText = (text = "") => {
      if (!text) return 0;
      const values = [...text.matchAll(/value:([^;]*);?/g)].map(match => match[1]?.trim() || '');
      const plainText = text.replace(/\[textbox.*?\]/g, '');
      const valueText = values.join('');
      return valueText.length + plainText.length;
    };
    return (
      <div onClick={() => (rowDisabled ? undefined : !isRowExpanded(rowId) ? toggleRowExpansion(rowId) : undefined)}>
        {fieldType === "title" ? text : ""}
        {(expanded || getTotalCharacterCountFromText(text) <= calculationLimit) && fieldType !== "title"
          ? replacePlaceholdersWithDropdowns(text, commentDropdowns, textType, rowId, rowUuid, rowDisabled, false, truncationLimit)
          : fieldType !== "title" && replacePlaceholdersWithDropdowns(text, commentDropdowns, textType, rowId, rowUuid, rowDisabled, true, truncationLimit)}
      </div>
    );
  };

  setTimeout(() => {
    let commentInputElements = document.querySelectorAll(".comment-cl-input");
    commentInputElements?.forEach((element) => {
      if (element !== null && element !== undefined) {
        const commentUUId = element.getAttribute("comment_uuid");
        element.onclick = (event) => {
          event.stopPropagation();
        };
        element.onblur = async (event) => {
          let commentIndex = commentListData?.findIndex((item) => item.uuid == commentUUId);
          const targetId = event.target.id;
          const newValue = event.target.value;
          let commentText = commentListData[commentIndex]?.comment_text;
          const textboxPattern = new RegExp(`\\[textbox id:${targetId}(;\\s*value:(.*?))?;?\\s*\\]`, 'g');
          commentText = commentText?.replace(textboxPattern, (match, fullValuePart, oldValue) => {
            if (fullValuePart) {
              return match.replace(oldValue, newValue);
            } else {
              return match.replace(`[textbox id:${targetId}`, `[textbox id:${targetId}; value:${newValue}`);
            }
          });
          let payload = { comment_uuid: commentUUId, comment_text: commentText };
          await updateInputValues(dispatch, payload);
        }
      }
    });

    let summaryInputElements = document.querySelectorAll(".summary-cl-input");
    summaryInputElements?.forEach((element) => {
      if (element !== null && element !== undefined) {
        const commentUUId = element.getAttribute("comment_uuid");
        element.onclick = (event) => {
          event.stopPropagation();
        };
        element.onblur = async (event) => {
          let commentIndex = commentListData?.findIndex((item) => item.uuid == commentUUId);
          const targetId = event.target.id;
          const newValue = event.target.value;
          let commentText = commentListData[commentIndex].summary_comment_text;
          const textboxPattern = new RegExp(`\\[textbox id:${targetId}(;\\s*value:(.*?))?;?\\s*\\]`, 'g');
          commentText = commentText?.replace(textboxPattern, (match, fullValuePart, oldValue) => {
            if (fullValuePart) {
              return match.replace(oldValue, newValue);
            } else {
              return match.replace(`[textbox id:${targetId}`, `[textbox id:${targetId}; value:${newValue}`);
            }
          });
          let payload = { comment_uuid: commentUUId, summary_comment_text: commentText };
          await updateInputValues(dispatch, payload);
        }
      }
    });
  }, 100)

  useEffect(() => {
    const commentUuid = storeData?.addCommentResponse?.comment?.uuid;
    if (!commentUuid) return;

    const defectImage = defectImages[uploadIndexRef.current];
    if (defectImage?.file) {
      handleUpload(defectImage, storeData.addCommentResponse);
      uploadIndexRef.current += 1;
    }
  }, [storeData?.addCommentResponse?.comment?.uuid]);

  return (
    <Dialog className="dialog-container-comment-library" open={showCommentLibraryModal} onClose={handleClose} aria-labelledby="category-modal" aria-describedby="category-modal-description">
      <div className="close-wrapper-new-category-right">
        <CloseIcon className="checkbox_container" onClick={handleClose} />
      </div>
      <DialogTitle className="comment-library-dialog-title">
        <span>{categoryName || categoryNameFromLocation || ""}</span> - Add comment
        <Box className="lineDetails__tab cl_tabs" sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs value={value} onChange={handleChange} aria-label="line_details_tab">
            <Tab className={`tab__label cl_tab_panel ${value === 0 ? "active" : "inactive"}`} label="Comment Library" {...a11yProps(0)} />
            <Tab className={`tab__label cl_tab_panel captitalize ${value === 1 ? "active" : "inactive"}`} label={"New comment"} {...a11yProps(1)} />
            <Tab className={`cl_tab_panel_image-defect-finder captitalize ${value === 2 ? "active" : "inactive"}`}
              label={"AI Defect Detector"}
              // icon={<MaskSparkle />}
              // iconPosition="end"
              {...a11yProps(2)}
            />
            <Typography variant="contained" size="small" className="ai-text"> <MaskSparkle /></Typography>
          </Tabs>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Grid item xs={12}>
          <Box sx={{ width: "100%" }}>
            <Box className={
              value === 0 || value === 1
                ? "dialog-content-comment-library"
                : value === 2 && (!datas || datas.length === 0)
                  ? "dialog-container-sidebar"
                  : value === 2 && datas?.length > 0
                    ? "dialog-container-image-defect-finder"
                    : ""
            } >
              {/* Comment library tab */}
              <TabPanel value={value} index={0} className="tab_panel_cLibrary">
                {storeData?.addCommentListLoader || loader ? (
                  <Box className="loader-container-comment-library" sx={{ width: "100%" }}>
                    <CircularProgress />
                  </Box>
                ) : (
                  <Box sx={{ width: "100%" }}>
                    <Grid container className="cl-search-container">
                      <Grid item xs={12} md={3} className="cl-search-bar">
                        <div className="cl-search">
                          <TextField
                            id="search-bar"
                            onChange={(e) => setSearchInput(e.target.value)}
                            sx={{
                              "& .MuiOutlinedInput-root": {
                                "&:hover .MuiOutlinedInput-notchedOutline": {
                                  borderColor: "#ccc", // Set your desired hover border color here
                                },
                                "& .MuiOutlinedInput-notchedOutline": {
                                  borderColor: "#ccc", // Initial border color
                                },
                              },
                            }}
                            variant="outlined"
                            placeholder="Search"
                            size="small"
                            InputProps={{
                              style: { height: "40px", paddingRight: "30px" },
                              inputProps: { style: { height: "40px", padding: "0 14px" } },
                            }}
                            style={{ height: "40px", width: "100%" }}
                          />
                          <SearchIcon className="cl-search-icon" />
                        </div>
                      </Grid>
                      <Grid item xs={12} md={3} mb={1}>
                        <FilterTags setLoader={setLoader} getClListForSearch={getClListForSearch} searchInput={debouncedSearch} setPage={setPage} categoryUuid={categoryUuid} templateGuid={templateGuid} categoryId={categoryId} dispatch={dispatch} getCommentLibraryList={getCommentLibraryList} searchData={searchData} filterTagList={storeData?.clTag} setCommentListData={setCommentListData} commentListData={commentListData} selectedFilterTagID={selectedFilterTagID} setSelectedFilterTagID={setSelectedFilterTagID} initialTableData={initialTableData} defaultCategories={storeData.defaultCategories} handleClearCategories={handleClearCategories} isNarrative={true} />
                      </Grid>
                      <Grid item xs={12} md={1.5}></Grid>
                    </Grid>
                    <TableContainer className="custom-table-container">
                      <Table stickyHeader sx={{ minWidth: 750 }} aria-labelledby="tableTitle" size={"medium"}>
                        <EnhancedTableHead
                          numSelected={selected?.length}
                          order={order}
                          orderBy={orderBy}
                          onSelectAllClick={handleSelectAllClick}
                          onRequestSort={handleRequestSort}
                          rowCount={commentListData?.length}
                        />
                        <TableBody>
                          {visibleRows?.map((row, index) => {
                            const isItemSelected = isSelected(row.uuid);
                            const labelId = `enhanced-table-checkbox-${index}`;
                            let rowDisabled = existingCommentUuids?.includes(row.uuid) ? true : false;
                            return (
                              <TableRow
                                hover
                                role="checkbox"
                                aria-checked={isItemSelected}
                                tabIndex={-1}
                                key={row.uuid}
                                selected={isItemSelected}
                                sx={{ cursor: "pointer" }}
                                className={`cl_row ${rowDisabled ? "disabled cl-row-disabled" : ""}`}
                              >
                                {/* Checkbox Column */}
                                <TableCell
                                  padding="checkbox"
                                  onClick={(event) => (rowDisabled ? undefined : handleClick(event, row.id, row))}
                                  className={`cl-checkbox-col ${rowDisabled ? (isItemSelected ? "cl-check-active" : "") : isRowExpanded(row.id) ? (isItemSelected ? "cl-check-active" : "") : ""}`}
                                  sx={{ width: "50px", minWidth: "50px", maxWidth: "50px" }}
                                >
                                  <Checkbox
                                    sx={{
                                      height: "37.5px !important",
                                      width: "37.5px !important",
                                      "& .MuiSvgIcon-root": { fontSize: "20px !important" },
                                    }}
                                    color="primary"
                                    checked={isItemSelected || rowDisabled}
                                    disabled={rowDisabled}
                                  />
                                </TableCell>
                                {/* Expand Icon Column */}
                                <TableCell
                                  id={labelId}
                                  scope="row"
                                  padding="none"
                                  className={`cl-row-status cl-exp-col ${rowDisabled ? "row_disabled" : ""}`}
                                  sx={{ width: "50px", textAlign: "center" }}
                                >
                                  <IconButton
                                    sx={{ height: "19.5px", width: "19.5px", "& .MuiSvgIcon-root": { fontSize: "19.5px !important" } }}
                                    onClick={() => (rowDisabled ? undefined : toggleRowExpansion(row.id))}
                                  >
                                    {rowDisabled ? <ExpandLessIcon className="disabled_collapse_cl_icon" /> : isRowExpanded(row.id) ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                                  </IconButton>
                                </TableCell>
                                {/* Title Column (Fixed Width) */}
                                <TableCell
                                  className={`cl-title-col ${rowDisabled ? "row_disabled" : ""}`}
                                  align="left"
                                  sx={{
                                    width: "250px", // Set fixed width
                                    maxWidth: "250px", // Prevent expansion
                                    minWidth: "250px", // Prevent shrinking
                                    overflow: "hidden",
                                    whiteSpace: "nowrap", // Prevent text wrapping
                                    textOverflow: "ellipsis", // Show "..." for overflow text
                                  }}
                                >
                                  <TruncatedText text={row.title} expanded={isRowExpanded(row.id)} fieldType={"title"} />
                                </TableCell>
                                {/* Comment Column */}
                                <TableCell className={`cl-comment-col ${rowDisabled ? "row_disabled" : ""}`} align="left" sx={{ minWidth: "300px", maxWidth: "400px", overflow: "hidden" }}>
                                  <TruncatedText
                                    text={row.comment_text !== null && row.comment_text !== undefined ? row.comment_text?.replace(/<\/?[^>]+(>|$)/g, "") : ""}
                                    expanded={isRowExpanded(row.id)}
                                    fieldType={"comment_text"}
                                    commentDropdowns={row?.comment_dropdowns}
                                    textType={"comment"}
                                    rowId={row?.id}
                                    rowUuid={row?.uuid}
                                    rowDisabled={rowDisabled}
                                  />
                                  <CommentTags tags={row?.tags} />
                                </TableCell>
                                {/* Summary Column */}
                                <TableCell className={`cl-summary-col ${rowDisabled ? "row_disabled" : ""}`} align="left" sx={{ minWidth: "250px", maxWidth: "350px", overflow: "hidden" }}>
                                  <TruncatedText
                                    text={row.summary_comment_text !== null && row.summary_comment_text !== undefined ? row.summary_comment_text?.replace(/<\/?[^>]+(>|$)/g, "") : ""}
                                    expanded={isRowExpanded(row.id)}
                                    fieldType={"summary_text"}
                                    commentDropdowns={row?.summary_comment_dropdowns}
                                    textType={"summary"}
                                    rowId={row?.id}
                                    rowUuid={row?.uuid}
                                    rowDisabled={rowDisabled}
                                  />
                                </TableCell>

                                {/* Summary Section Column */}
                                <TableCell className={`cl-rating-col ${rowDisabled ? "row_disabled" : ""}`} align="left" sx={{ width: "150px", textAlign: "center" }}>
                                  {row?.summaries?.length !== 0
                                    ? row?.summaries?.map((element) => (
                                      <div className="cl_rating_square_container">
                                        <div
                                          className="rating_square"
                                          style={{
                                            background: `${element?.summary?.color}`,
                                            padding: "4px",
                                          }}
                                        ></div>
                                        <div className="cl_rating_name_text">{element?.summary?.name}</div>
                                      </div>
                                    ))
                                    : ""}
                                </TableCell>

                                {/* Global Column */}
                                <TableCell className={`cl-global-col ${rowDisabled ? "row_disabled" : ""}`} align="left" sx={{ width: "100px", textAlign: "center" }}>
                                  <div>
                                    <PublicIcon />
                                  </div>
                                </TableCell>
                              </TableRow>
                            );
                          })}
                        </TableBody>
                      </Table>
                    </TableContainer>
                    <TablePagination
                      rowsPerPageOptions={[rowsPerPage]}
                      component="div"
                      count={totalCount}   // backend total
                      rowsPerPage={rowsPerPage}
                      page={page}
                      onPageChange={handleChangePage}
                      ActionsComponent={TablePaginationActions}
                    />
                    {/* </Paper> */}
                  </Box>
                )}
              </TabPanel>
              {/* New comments tab */}
              <TabPanel value={value} index={1} className="tab_panel_cLibrary">
                <CLAddCommentModal
                  categoryName={categoryName}
                  categoryNameFromLocation={categoryNameFromLocation}
                  commentTitle={commentTitle}
                  setCommentTitle={setCommentTitle}
                  commentSummaryTag={commentSummaryTag}
                  setCommentSummaryTag={setCommentSummaryTag}
                  commentTag={commentTag}
                  setCommentTag={setCommentTag}
                  commentText={commentText}
                  setCommentText={setCommentText}
                  commentSummary={commentSummary}
                  setCommentSummary={setCommentSummary}
                  templateId={templateId}
                  categoryId={categoryId}
                  selectedFilterTagID={selectedFilterTagID}
                />
              </TabPanel>
              <TabPanel value={value} index={2} className="tab_panel_cLibrary">
                <AIDefectFinder
                  loading={loading}
                  openData={openData}
                  medialLibery={medialLibery}
                  sideBarActive={storeData?.reportSideBarActive}
                  RenderContent={RenderContent}
                  handleImageUpload={handleImageUpload}
                  setMedialLibery={setMedialLibery}
                  storeData={storeData}
                  images={images}
                  handleRemoveImage={handleRemoveImage}
                  dataLoading={dataLoading}
                  setDataLoading={setDataLoading}
                  defaultSelect={defaultSelect}
                  datas={datas}
                  setDefaultSelect={handleSelect}
                  selectedContent={selectedContent}
                  setSelectedContent={setSelectedContent}
                  setDatas={setDatas}
                  handleRetry={handleRetry}
                  handleCheckbox={handleCheckbox}
                  handleSelect={handleSelect}
                  value={value}
                  selectedImages={selectedImages}
                  setSelectedImages={setSelectedImages}
                  onDragtoggle={onDragtoggle}
                  setOnDragToggle={setOnDragToggle}
                  selectedMediaFiles={selectedMediaFiles}
                  setSelectedMediaFiles={setSelectedMediaFiles}
                  type="non-narrative"
                  remainingImages={remainingImages}
                  promptUsed={tabValue}
                  manualPrompt={additionalInfo}
                  includeRecommendation={includeRecommendation}
                  categoryName={categoryName}
                  lineName={lineData?.prompt}
                />
              </TabPanel>
            </Box>
          </Box>
        </Grid>
      </DialogContent >
      <Divider />
      <>
        <DialogActions className="comment-library-action">
          {value !== 2 &&
            <div className={`comment-library-checkbox-container ${value === 0 ? "hidden" : "visible"}`}>
              {value === 1 ? (
                <>
                  {reportWriterSettingsAccess === 1 &&
                    <>
                      <FormGroup>
                        <FormControlLabel
                          className="cl_checkbox"
                          control={
                            <Checkbox
                              checked={addToLibrary}
                              onChange={() => setAddToLibrary(!addToLibrary)}
                              sx={{
                                height: "24px !important",
                                width: "24px !important",
                                marginRight: "8px",
                                "& .MuiSvgIcon-root": { height: "24px !important", width: "24px !important" },
                              }}
                            />
                          }
                          label="Save to comment library"
                        />
                      </FormGroup>
                    </>
                  }
                </>
              ) : null}
            </div>}
          <div className="">
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'flex-start',
                alignItems: 'center',
              }}
            >
              {(value === 2 && (loading || selectedContent)) && (
                <Typography
                  variant="caption"
                  className="open-sans-text"
                  sx={{
                    color: '#777777',
                    maxWidth: 481,
                    verticalAlign: 'middle',
                    fontFamily: '"Open Sans", sans-serif !important',
                    fontSize: '11px !important',
                    fontWeight: '400 !important',
                    lineHeight: '100% !important',
                    letterSpacing: '0px !important',
                    display: 'inline-block',
                    textAlign: 'left'
                  }}
                >
                  <span className="open-sans-text">Comments generated by AI are intended to assist and may contain errors or inaccuracies.</span> <br />
                  <span className="open-sans-text" style={{ marginTop: '4px', display: 'inline-block' }}>Please review and verify all content before submitting your report.</span>
                </Typography>
              )}
            </Box>
          </div>
          <div className="comment-library-action-btn">
            <Button className="cl-cancel-btn" onClick={handleClose}>
              Cancel
            </Button>
            <Button
              disabled={
                value === 1 ? (commentTitle?.trim() === "" &&
                  (commentText?.innerHTML?.trim() === "" ||
                    commentText?.innerHTML?.trim() === "<p><br></p>" ||
                    preprocessHTMLContent(commentText?.innerHTML) === ""))
                  : value === 2
                    ? (getButtonLabel() !== 'Analyze images' && checkedCount === 0) || images.length === 0 || disable || images.some((img) => dataLoading[img?.file?.name] === true)
                    || !images.some((img) => {
                      const file = img.file || img;
                      const fileType = file.type || img.type;
                      const fileSize = file.size || img.size;
                      return (fileSize <= MAX_FILE_SIZE && ALLOWED_TYPES.includes(fileType));
                    })
                    : Array.isArray(selected) && selected.length === 0 && images.length === 0
              }
              className={getButtonLabel() === "Analyze images" ? "cl-analyze-btn" : "cl-add-btn"}
              onClick={() => {
                if (value === 1) {
                  return handleAddNewComment();
                }
                if (value === 2) {
                  return getButtonLabel() !== 'Analyze images'
                    ? handleAnalyseDefect()
                    : handleNext(false);
                }
                if (Array.isArray(selected) && selected.length > 0) {
                  return handleAddSelectedComment();
                }
                return null;
              }}
            >
              {value === 2 && !selectedContent && !loading ? <Sparkle /> : ""}
              {getButtonLabel()}
            </Button>
          </div>
        </DialogActions>
      </>
    </Dialog >
  );
};

export default CommentLibraryModal;